if (!customElements.get('wholesale-button')) {
  class WholesaleButton extends HTMLElement {
    constructor() {
      super();
    }

    static observedAttributes = ['data-price-per-item'];

    static currenciesWithoutDecimals = [
      'BIF', // Burundian Franc
      'CLP', // Chilean Peso
      'DJF', // Djiboutian Franc
      'GNF', // Guinean Franc
      'ISK', // Icelandic Króna
      'JPY', // Japanese Yen
      'KMF', // Comorian Franc
      'KRW', // South Korean Won
      'PYG', // Paraguayan Guarani
      'RWF', // Rwandan Franc
      'UGX', // Ugandan Shilling
      'VND', // Vietnamese Đồng
      'VUV', // Vanuatu Vatu
      'XAF', // Central African CFA Franc
      'XOF', // West African CFA Franc
      'XPF', // CFP Franc
    ];

    /**
     * Formats a number as currency.
     *
     * @param {Number} amount - The amount to format. Using the same format
     * as shopify's filters: 9000 is 90.00 for decimal currencies.
     * @returns {String} The formatted currency string.
     */
    formatCurrency(amount) {
      const divisor = WholesaleButton.currenciesWithoutDecimals.includes(
        window.currency,
      )
        ? 1
        : 100;

      return new Intl.NumberFormat(window.shopLocale, {
        style: 'currency',
        currency: window.currency,
      }).format(amount / divisor);
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (!name.includes('price')) return;

      const targetSpan = this.querySelector('[js-wholesale-target-span]');
      this.priceFormat = this.formatCurrency(newValue);

      targetSpan.textContent = window.priceEach.replace(
        '{{ price }}',
        this.priceFormat,
      );

      this.dispatchEvent(
        new CustomEvent('line-item:update-prices', { bubbles: true }),
      );
    }

    handleClick(event) {
      event.preventDefault();

      this.dispatchEvent(
        new CustomEvent('selector:update-price', {
          detail: {
            price: this.priceFormat,
            minQuantity: Number(this.getAttribute('data-min-quantity')),
          },
          bubbles: true,
        }),
      );

      this.dispatchEvent(
        new CustomEvent('wholesale:quantity-change', {
          bubbles: true,
          detail: {
            quantity: Number(this.getAttribute('data-min-quantity')),
            discount: Number(this.getAttribute('data-percent-discount')),
            price: Number(this.getAttribute('data-price')),
            variantId: Number(this.getAttribute('data-variant-id')),
          },
        }),
      );
    }

    connectedCallback() {
      this.addEventListener('click', this.handleClick.bind(this));
    }
  }

  customElements.define('wholesale-button', WholesaleButton);
}
